/**
 * Peck Pirates Esports Platform - Firestore Schema Definitions
 * Multi-tenant data model using subcollection strategy
 */
// ============================================================================
// Collection Path Helpers
// ============================================================================
export const CollectionPaths = {
    users: 'users',
    schools: 'schools',
    students: (schoolId) => `schools/${schoolId}/students`,
    rosters: (schoolId) => `schools/${schoolId}/rosters`,
    attendance: (schoolId) => `schools/${schoolId}/attendance`,
    events: 'events',
    checkins: 'checkins',
    permissionSlips: 'permissionSlips',
    playerRoster: 'playerRoster',
    // Season data collections
    seasonStandings: 'seasonStandings',
    tournamentResults: 'tournamentResults',
    matchResults: 'matchResults',
    // Player dashboard collections
    scoutingReports: 'scoutingReports',
    teamComments: 'teamComments',
    eventVods: 'eventVods',
    // SSBU Ladder system
    ssbuLadder: 'ssbuLadder',
    ssbuChallenges: 'ssbuChallenges',
    ssbuLadderSettings: 'settings/ssbuLadder',
    // Bug reporting
    bugReports: 'bugReports',
    // Tournament data
    tournamentMatches: 'tournamentMatches',
};
